import { Component } from '@angular/core';

@Component({
  selector: 'app-gestion-glosario',
  templateUrl: './gestion-glosario.component.html',
  styleUrl: './gestion-glosario.component.scss',
})
export class GestionGlosarioComponent {}
